export default __webpack_public_path__ + "static/media/Screenshot_20.e6e2be33.png";